import React from 'react';
import HomeServiceItem from '../../../../components/HomeServiceItem/HomeServiceItem';

const ServiceArea = () => {
   return (
      <>
         <section className="tp-services-area theme-dark-bg">
            <div className="tp-custom-container">
               <div className="tp-services-bg grey-bg pt-120 pb-90 z-index">
                  <div className="container">
                     <div className="row justify-content-center">
                        <div className="col-lg-8">
                           <div className="tp-section-title-wrapper text-center mb-55 wow fadeInUp" data-wow-delay=".1s">
                              <h5 className="tp-section-subtitle section__sm__title common-yellow-shape mb-25">Nos services populaires</h5>
                              <h2 className="tp-section-title">Notre succès en matière de nettoyage <br/>Améliorez votre désordre</h2>
                           </div>
                        </div>
                     </div>
                     <div className="row">

                        <HomeServiceItem icon_name="pot" title="Nettoyage Expert de Votre Cuisine" subtitle="Transformez votre cuisine en un espace étincelant et hygiénique ! Notre service spécialisé élimine graisses tenaces, bactéries et désordre" />

                        <HomeServiceItem icon_name="vacuum-cleaner" title="Nettoyage de tapis"  subtitle="Élimination des taches, allergènes et odeurs – Résultat professionnel garanti. Nettoyage à la vapeur (extraction)" />

                        <HomeServiceItem icon_name="house-cleaning" title="Nettoyage de la maison"  subtitle="Luminosité garantie – Intérieur & Extérieur – De la maison à l’immeuble. Décrassage minutieux, Lavage sans traces, Finitions impeccables" />

                        <HomeServiceItem icon_name="desk" title="Nettoyage de bureaux"  subtitle="Service quotidien/sur mesure – Zéro perturbation – Écoresponsable.  Nettoyage quotidien, Grands espaces (open spaces, salles de réunion > 50m²), Zones sensibles" />

                        <HomeServiceItem icon_name="cleaning" title="Nettoyage des routes"  subtitle="Service complet pour voiries, dépendances vertes et équipements publics. Chaussées, Accotements, Glissières & Panneaux, Évacuations, Espaces verts" />

                        <HomeServiceItem icon_name="window" title="Nettoyage de vitres"  subtitle="100% sans traces - Écologique - De la maison aux immeubles. Décapage intelligent, Raclettage professionnel, Contrôle lumière rasante" />

                     </div>
                  </div>
               </div>
            </div>
         </section>
      </>
   );
};

export default ServiceArea;